module.exports = __webpack_public_path__ + "img/3ne.155e8ac0.svg";